export { IrPage as default } from '@/components/enpages/Contact/ir'
